import { LabeledRow } from "@components/LabeledRow";
import { FetchCustomerData, TelephoneType } from "@customTypes/responses/customer";
import React from "react";
import { telephoneTypeDictionary } from "../tabs/constants";

type TelephoneListProps = {
  telephones: FetchCustomerData["telephone"];
};

const TelephoneList: React.FC<TelephoneListProps> = ({ telephones }) => {
  const typeSet = new Set<TelephoneType>();
  telephones.forEach((telephone) => typeSet.add(telephone.typeEnum));
  const telephoneListByType: FetchCustomerData["telephone"][] = [];

  typeSet.forEach((type) => {
    telephoneListByType.push(telephones.filter((telephone) => telephone.typeEnum == type));
  });

  return (
    <>
      {telephoneListByType.map((telephones) => {
        const type = telephones[0].typeEnum;
        const valueList = telephones.map((telephone) => telephone.number);

        return <LabeledRow key={type} label={telephoneTypeDictionary[type]} values={valueList} />;
      })}
    </>
  );
};

export default TelephoneList;
